
import { Component, Mixins, Prop } from "vue-property-decorator";
import DashboardMixin from "./dashboard.mixin";
import { Utox } from "./dashboard.types";

@Component
export default class UtoxResult extends Mixins(DashboardMixin) {
  @Prop() utoxResultShow!: boolean;
  @Prop() selectedUtox!: Utox;

  closeModal() {
    this.$emit('update:utoxResultShow', false);
  }
}
